import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["status", "dropzone", "lockedNotice", "lockedNote", "uploadArea", "input", "note", "cta"];

  static values = {
    hasExistingImage: Boolean
  };

  connect() {
    this.sync();
  }

  sync() {
    const cooked = this.isCooked();
    const hasSelectedFile = this.hasSelectedFile();

    this.inputTarget.disabled = !cooked;
    this.inputTarget.setAttribute("aria-disabled", String(!cooked));

    this.dropzoneTarget.classList.toggle("pointer-events-none", !cooked);
    this.dropzoneTarget.classList.toggle("cursor-not-allowed", !cooked);
    this.dropzoneTarget.classList.toggle("opacity-60", !cooked);
    this.dropzoneTarget.classList.toggle("cursor-pointer", cooked);

    if (this.hasLockedNoticeTarget) {
      this.lockedNoticeTarget.classList.toggle("hidden", cooked);
    }

    if (this.hasLockedNoteTarget) {
      this.lockedNoteTarget.textContent = this.noteText(false, {
        hasSelectedFile,
        hasExistingImage: this.hasExistingImageValue
      });
    }

    if (this.hasUploadAreaTarget) {
      this.uploadAreaTarget.classList.toggle("hidden", !cooked);
    }

    if (this.hasCtaTarget) {
      this.ctaTarget.textContent = cooked ? "Add photo" : "Photo locked";
    }

    if (this.hasNoteTarget) {
      this.noteTarget.textContent = this.noteText(cooked, {
        hasSelectedFile,
        hasExistingImage: this.hasExistingImageValue
      });
    }
  }

  isCooked() {
    return this.statusTarget.value === "cooked";
  }

  hasSelectedFile() {
    return this.inputTarget.files && this.inputTarget.files.length > 0;
  }

  noteText(cooked, { hasSelectedFile, hasExistingImage }) {
    if (cooked) {
      return "Optional. Add a photo if you want this entry to show an image on public pages.";
    }

    if (hasExistingImage) {
      return "Photo is saved but only appears when this meal is marked cooked.";
    }

    if (hasSelectedFile) {
      return "This photo is selected, but only appears when this meal is marked cooked.";
    }

    return "Photos can be added after this is marked cooked.";
  }
}
